import { Group } from '@mantine/core';
import { SettingsButton } from '@repo/common/components';
import { SettingsBlock } from '@repo/common/components/SettingsBlock';
import { Badge, Button, ResourceIcon, Text } from '@repo/foundations';
import { useInvoiceHistory } from './hooks';

export function InvoiceHistoryController() {
	const {
		creditsData,
		formatCurrency,
		getStatusBadgeVariant,
		formatDate,
		handleViewInvoice,
	} = useInvoiceHistory();

	return (
		<>
			<SettingsButton
				title="Invoice history"
				description="Invoices are issued for subscription charges and credits purchases"
				leftComponent={<ResourceIcon iconName="fileText" />}
			/>

			{/* Invoice History Header */}
			<SettingsBlock
				title="Date"
				description="Invoice Type"
				rightComponent={
					<Group
						spacing="md"
						style={{ minWidth: '300px', justifyContent: 'flex-end' }}
					>
						<Text
							size="sm"
							fw={500}
							style={{ minWidth: '80px', textAlign: 'center' }}
						>
							Status
						</Text>
						<Text
							size="sm"
							fw={500}
							style={{ minWidth: '80px', textAlign: 'right' }}
						>
							Amount
						</Text>
						<Text
							size="sm"
							fw={500}
							style={{ minWidth: '60px', textAlign: 'center' }}
						>
							Actions
						</Text>
					</Group>
				}
			/>

			{/* Invoice History Items */}
			{creditsData?.results?.map((credit) => (
				<SettingsBlock
					key={credit.id}
					title={formatDate(credit.created_at)}
					description={credit.description}
					rightComponent={
						<Group
							spacing="md"
							style={{ minWidth: '300px', justifyContent: 'flex-end' }}
						>
							<Badge
								variant={getStatusBadgeVariant(credit.status)}
								size="sm"
								style={{ minWidth: '80px', textAlign: 'center' }}
							>
								{credit.status}
							</Badge>
							<Text
								size="sm"
								fw={500}
								style={{ minWidth: '80px', textAlign: 'right' }}
							>
								{formatCurrency(Number(credit.amount))}
							</Text>
							<Button
								variant="tertiary"
								size="sm"
								onClick={() => handleViewInvoice(credit.invoice_url || null)}
								disabled={!credit.invoice_url}
								style={{ minWidth: '60px' }}
							>
								View
							</Button>
						</Group>
					}
				/>
			))}

			{/* Empty State */}
			{(!creditsData?.results || creditsData.results.length === 0) && (
				<SettingsBlock
					title="No invoices yet"
					description="Invoices will appear here once you purchase credits"
				/>
			)}
		</>
	);
}
